import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { urlAssets } from '../../Constants';
import HeadingCategory from './HeadingCategory';
import BestPlayer from './BestPlayer';

const Categories = props => {

    const { data } = props;
    const [ titleEspecial, brand, epigraph ] = Object.values(data[0]);
    const categories = Object.values(data[1]);
    const votes = Object.values(data[2]);
    
    const HeadingVote = ({children}) => <h2 className="mb-0 pb-2 pb-md-3 border-bottom border-dark heading-vote">{children}</h2>;
    const VoterName = ({children}) => <span className="voter-name">{children}</span>;
    const VoterJob = ({children}) => <span className="voter-job">{children}</span>;

    return (
        <Fragment key="heading">
            <section className="my-2 px-2 px-md-0">
                <section className="text-center">
                    <LazyLoadImage
                        alt={titleEspecial}
                        className="img-fluid"
                        effect="blur"
                        src={`${urlAssets}/img/premiosdt2021-home.png`}
                    />
                    <h1 className="mb-0 title">{titleEspecial} <span className="ec-title">{brand}</span></h1>
                    <p className="mb-0 mx-auto px-2 px-md-5 epigraph">{epigraph}</p>
                </section>
                <section className="mt-3 mt-md-5 text-center">
                    <LazyLoadImage
                        alt={titleEspecial}
                        className="d-block img-fluid"
                        effect="blur"
                        src={`${urlAssets}/img/mano.svg`}
                    />
                    <span className="d-table mx-auto pb-1 category">Selecciona la categoría</span>
                </section>
            </section>
            <section className="mx-auto mt-4 mb-5 px-2 px-md-0 content-winners">
            {
                categories.map(category => 
                    <Fragment key={category.id}>
                        <HeadingCategory key={category.slugCategory} name={category.name} backGroundColorBlock={category.backGroundColorBlock} />                            
                        <section key={`${category.id} - ${category.slugCategory}`} className="row row-md-cols-2 mx-auto g-2 justify-content-between">
                        {
                            (category.winners).map((winner, i) => {
                                return (!winner.subgroup)
                                ? <BestPlayer key={winner.slug} slugCategory={category.slugCategory} colorPlayer={category.colorPlayer} urlAssets={urlAssets} winnerInfo={winner} />
                                : <section key={i} className="col-md-auto px-0">
                                    <section className="row flex-column gx-0 gy-2 px-0" key={winner.subgroup.slug}>
                                        {(winner.subgroup).map(sgroup => 
                                                <BestPlayer key={sgroup.id} slugCategory={category.slugCategory} colorPlayer={category.colorPlayer} urlAssets={urlAssets} winnerInfo={sgroup} />          
                                            )                                          
                                        }
                                    </section>
                                </section>
                            })
                        }
                        </section>
                    </Fragment>
                )
            }    
            </section>  
            <section className="mx-auto my-3 my-md-5 px-2 px-md-0 content-winners">
            {
                votes.map(vote => 
                    <section key={vote.id} className="my-3 my-md-5">
                        <HeadingVote key={vote.id}>{vote.title}</HeadingVote>
                        <section className="my-1 my-md-3">
                            <ul className="list-unstyled">
                            {
                                (vote.voters).map((voter, i) => 
                                    <li key={i}><VoterName>{voter.name}</VoterName><VoterJob>{` - ${voter.job}`}</VoterJob></li>
                                )
                            }  
                            </ul>                          
                        </section> 
                    </section> 
                )
            }
            </section>          
        </Fragment>
    )
}

export default Categories;

Categories.propTypes = {
    data: PropTypes.array.isRequired
}